// Vars that will affect on heatmap tooltip regions detecting/joining

// Also you can change the influence formula at heatmapKernel/influence
export const matrixKernelDimension = 13;
export const pointsGroupRadius = 8;
export const pointsMinWeight = 20;
export const tooltipAddableRadius = 15;
